import React from 'react';
import { CheckIcon, DownloadIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
import { CollectionMockup } from '../CollectionMockup';
import { StitchLine } from '../StitchLine';
import { OFFER_FEATURES } from '../../data/collection';
import { BUY_LABEL, PRICE } from '../../data/checkout';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-ivory-deep" data-id="element-253" data-mp="akwackide8hz">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-254" data-mp="6jay91dnty8u">
        <div className="grid min-w-0 grid-cols-1 items-center gap-8 rounded-[24px] bg-paper p-5 ring-1 ring-ivory-line sm:gap-10 sm:rounded-[28px] sm:p-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-14 lg:p-12" data-id="element-255" data-mp="1ppxj1komq5y">
          <div className="order-2 min-w-0 lg:order-1" data-id="element-256" data-mp="3nzj3kpk5z6y5">
            <CollectionMockup className="max-w-[min(340px,100%)] lg:max-w-[600px]" data-id="element-257" data-mp="3iz4vj7ikbx04" />
          </div>

          <div className="order-1 min-w-0 lg:order-2" data-id="element-258" data-mp="3ewrngcgcfn06">
            <StitchLine className="w-16" data-id="element-259" data-mp="3ez4cf9kiqxmq" />
            <h2 id="oferta-title" className="mt-4 font-serif text-[2rem] font-semibold leading-[1.1] text-graphite text-balance sm:text-[2.5rem]" data-id="element-260" data-mp="1arquo8k4izr3">
              Llevate la colección completa de Pequeñas Puntadas™.
            </h2>

            <ul className="mt-6 grid grid-cols-1 gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-261" data-mp="15sxiqkkhjgt1">
              {OFFER_FEATURES.map(feature => <li key={feature} className="flex items-start gap-2.5 text-[1.02rem] font-semibold text-graphite" data-id="element-262" data-mp="1tjjog570oozv">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-tint" data-id="element-263" data-mp="1yh31x2vw4xqr">
                    <CheckIcon className="h-3.5 w-3.5 text-sage-ink" strokeWidth={3} aria-hidden data-id="element-264" data-mp="1kjwmniadlh6a" />
                  </span>
                  {feature}
                </li>)}
            </ul>

            <div id="offer-price" className="mt-8 border-t border-ivory-line pt-6" data-id="element-265" data-mp="94risayidcl3">
              <p className="text-[0.98rem] text-graphite-soft" data-id="element-266" data-mp="d5l54zwayjbv">
                Precio de referencia <span className="font-semibold line-through" data-id="element-267" data-mp="2fqe0jr8hkkwb">{PRICE.compareAtLabel}</span>
              </p>
              <p className="mt-1 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-268" data-mp="2ascf4znl89ho">
                <span className="font-serif text-[3.2rem] font-semibold leading-none text-graphite sm:text-[3.6rem]" data-id="element-269" data-mp="25zt5gds0tyi5">
                  {PRICE.label}
                </span>
                <span className="text-[1rem] font-bold text-graphite-soft" data-id="element-270" data-mp="1x0z1g2cd25uk">ARS · {PRICE.note}</span>
              </p>
            </div>

            <div className="relative mt-6 rounded-[16px] bg-blush px-5 py-5 sm:px-6" data-id="element-271" data-mp="1rzrshzyhf0mb">
              <span aria-hidden className="pointer-events-none absolute inset-[6px] rounded-[11px] border border-dashed border-coral/50" data-id="element-272" data-mp="1n3b7hemkx2dg" />
              <p className="relative font-serif text-[1.2rem] font-semibold text-graphite" data-id="element-273" data-mp="1i59jqge7kevn">{PRICE.perModelLead}</p>
              <p className="relative mt-1 font-serif text-[1.65rem] font-semibold leading-tight text-coral-ink sm:text-[1.85rem]" data-id="element-274" data-mp="3ch6her38ugz5">
                {PRICE.perModelHighlight}
              </p>
              <p className="relative mt-1.5 text-[0.9rem] font-semibold text-graphite-soft" data-id="element-275" data-mp="3kwdui5jdyq94">{PRICE.perModelNote}</p>
            </div>

            <div className="mt-7" data-id="element-276" data-mp="3tq8qamymb4c3">
              <CheckoutButton id="offer-cta" label={BUY_LABEL} size="lg" data-id="element-277" data-mp="3tr1yzth503wv" />
            </div>
            <p className="mt-4 flex items-start gap-2 text-[0.95rem] leading-relaxed text-graphite-soft" data-id="element-278" data-mp="2jpjrjzte0jl">
              <DownloadIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage-ink" aria-hidden data-id="element-279" data-mp="3215mf8an7vzz" />
              {PRICE.delivery} Son archivos digitales: no se envían productos físicos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}